import { cn } from '@/lib/utils';

/** The product name, in one place, so renaming it is one edit and not thirty. */
export const PRODUCT_NAME = 'Oro Star Portal';

/**
 * The lockup: a red mark, the name, and a tracked-out descriptor beneath it.
 *
 * `tone` picks the text colours rather than the mark — the mark is the same
 * red on every surface, which is what makes it read as a mark and not as a
 * decoration that happens to change with the background.
 */
export function Brand({
  tone = 'light',
  size = 'md',
  showTagline = true,
  className,
}: {
  tone?: 'light' | 'dark';
  size?: 'sm' | 'md';
  showTagline?: boolean;
  className?: string;
}) {
  const markSize = size === 'sm' ? 'h-8 w-8 text-[11px]' : 'h-10 w-10 text-xs';

  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <span
        className={cn(
          'flex shrink-0 items-center justify-center rounded-lg bg-primary font-black tracking-tight text-primary-foreground',
          markSize,
        )}
        aria-hidden
      >
        ORO
      </span>
      <span className="min-w-0 leading-tight">
        <span
          className={cn(
            'block truncate font-extrabold tracking-tight',
            size === 'sm' ? 'text-[13px]' : 'text-sm',
            tone === 'dark' ? 'text-white' : 'text-slate-900',
          )}
        >
          ORO STAR
        </span>
        {showTagline && (
          <span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-primary">
            Portal
          </span>
        )}
      </span>
    </span>
  );
}
